export const debounce = (fn, wait) => {
  let timeout = 0
  return function() {
    clearTimeout(timeout)
    timeout = setTimeout(() => fn.apply(this, arguments), wait)
  }
}
